import r from "./index205.mjs";
import m from "./index212.mjs";
function n(t, a) {
  m(2, arguments);
  var i = r(t), f = r(a), e = i.getTime() - f.getTime();
  return e < 0 ? -1 : e > 0 ? 1 : e;
}
export {
  n as default
};
//# sourceMappingURL=index329.mjs.map
